<template>
  <div class="container">

    <!--北向きカメラ-->
    <div class="contents-north" v-if="direction === 'north'">
      <img class="career-door-button-north" src="../../assets/img/building_a/corridor_btn_career.png" alt="進路指導室"
           @click="showModal = true">
      <img class="forward-button-north" src="../../assets/img/arrow.png" alt="進む" @click="moveToA11n">
      <img class="back-button-north" src="../../assets/img/arrow.png" alt="戻る" @click="moveToA13s">
    </div>

    <!--南向きカメラ-->
    <div class="contents-south" v-if="direction === 'south'">
      <img class="career-door-button-south" src="../../assets/img/building_a/corridor_btn_career.png" alt="進路指導室"
           @click="showModal = true">
      <img class="forward-button-south" src="../../assets/img/arrow.png" alt="進む" @click="moveToA13s">
      <img class="back-button-south" src="../../assets/img/arrow.png" alt="戻る" @click="moveToA11n">
    </div>

    <!--ログインモーダル-->
    <modal v-if="showModal" @close="showModal = false">
      <div class="app-modal">
        <h3>進路指導室について</h3>
        <p>進路指導室では、各大学の進路相談窓口の方に学校説明を行っていただいています。</p>
        <a class="enter-button" href="https://world-dev.vr-school.jp/#/counseling">進路指導室に入る</a>
        <h3>iPhone / iPad (iOS 12.2以降) をご利用の方へ</h3>
        <p>VRでの表示をお楽しみいただくため、下記の手順に従ってSafariの設定変更をお願いいたします。</p>
        <p>1. ホーム画面から「設定」を開き、「Safari」を選択</p>
        <img src="../../assets/img/building_a/career_modal_setting_1.png" alt="設定→Safari">
        <p>2. 「モーションと画面の向きのアクセス」をオンにする</p>
        <img src="../../assets/img/building_a/career_modal_setting_2.png" alt="モーションと画面の向きのアクセスをオン">
      </div>
    </modal>
  </div>
</template>

<script>
  import Modal from '@/components/Modal';

  export default {
    name: "Corridor_a_1_2",
    components: {
      Modal
    },
    data() {
      return {
        direction: undefined,
        showModal: false
      }
    },
    methods: {
      moveToA11n() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/corridor/a11n");
      },
      moveToA13s() {
        this.$emit("play-sound", "audio/vrschool_se_select.mp3");
        this.$router.push("/corridor/a13s");
      }
    },
    created() {
      switch (this.$route.path) {
        case '/corridor/a12n':
          this.direction = 'north';
          break;
        case '/corridor/a12s':
          this.direction = 'south';
          break;
      }
    }
  }
</script>

<style scoped>

  /* 北向きカメラ */
  .contents-north {
    height: 100%;
    background: url("../../assets/img/building_a/corridor_a_1_2_n_bg.png") no-repeat fixed center;
    background-size: contain;

    -webkit-perspective: 50vw;
    -moz-perspective: 50vw;
  }

  .forward-button-north {
    position: absolute;
    left: 46.5%;
    bottom: 33%;
    width: 7%;
    cursor: pointer;
    animation: move-forward-arrow 3s ease-in-out infinite;
  }

  .back-button-north {
    position: absolute;
    left: 43%;
    bottom: 16px;
    width: 14%;
    cursor: pointer;
    animation: move-back-arrow 3s ease-in-out infinite;
  }

  .career-door-button-north {
    position: absolute;
    left: 8%;
    bottom: 30%;
    width: 20%;
    cursor: pointer;
    animation: float-left 3s ease-in-out infinite;
  }

  @keyframes float-left {
    0% {
      transform: translateY(0px) rotateY(90deg) rotateZ(-2deg);
    }
    50% {
      transform: translateY(16px) rotateY(90deg) rotateZ(-2deg);
    }
    100% {
      transform: translateY(0px) rotateY(90deg) rotateZ(-2deg);
    }
  }

  /* 南向きカメラ */
  .contents-south {
    height: 100%;
    background: url("../../assets/img/building_a/corridor_a_1_2_s_bg.png") no-repeat fixed center;
    background-size: contain;

    -webkit-perspective: 50vw;
    -moz-perspective: 50vw;
  }

  .forward-button-south {
    position: absolute;
    left: 46%;
    bottom: 29%;
    width: 8%;
    cursor: pointer;
    animation: move-forward-arrow 3s ease-in-out infinite;
  }

  .back-button-south {
    position: absolute;
    left: 43%;
    bottom: 16px;
    width: 14%;
    cursor: pointer;
    animation: move-back-arrow 3s ease-in-out infinite;
  }

  .career-door-button-south {
    position: absolute;
    right: 4%;
    bottom: 30%;
    width: 23%;
    cursor: pointer;
    animation: float-right 3s ease-in-out infinite;
  }

  @keyframes float-right {
    0% {
      transform: translateY(0px) rotateX(-2deg) rotateY(-90deg);
    }
    50% {
      transform: translateY(16px) rotateX(-2deg) rotateY(-90deg);
    }
    100% {
      transform: translateY(0px) rotateX(-2deg) rotateY(-90deg);
    }
  }

  /* 共通 */

  @keyframes move-forward-arrow {
    0% {
      transform: translateZ(32px) rotateX(70deg);
    }
    50% {
      transform: translateZ(0px) rotateX(70deg);
    }
    100% {
      transform: translateZ(32px) rotateX(70deg);
    }
  }

  @keyframes move-back-arrow {
    0% {
      transform: translateZ(0px) rotateX(-110deg);
    }
    50% {
      transform: translateZ(16px) rotateX(-110deg);
    }
    100% {
      transform: translateZ(0px) rotateX(-110deg);
    }
  }

  /* モーダル */
  .app-modal {
    background-color: #000000;
    color: #FFFFFF;
    padding: 16px;
    height: 100%;
    overflow-y: scroll;
  }

  .app-modal > * {
    margin-bottom: 8px;
  }

  .app-modal > img {
    width: 100%;
  }

  .enter-button {
    display: block;
    text-align: center;
    background-color: #FFFFFF;
    color: #000000;
    width: 160px;
    margin: 16px auto;
    padding: 8px 16px;
    border-radius: 4px;
  }

  .enter-button:link,
  .enter-button:hover,
  .enter-button:active,
  .enter-button:visited {
    color: #000000;
    text-decoration: none;
  }

</style>